import { z } from "zod";
import { TopolBlockSchema } from "../commonSchema";

const TopolCarouslElementSchema = z.object({
  tagName: z.literal("mj-carousel-image"),
  attributes: z
    .object({
      src: z.string().catch(""),
      href: z.string().trim().optional().catch(undefined),
      alt: z.string().optional().catch(undefined),
      title: z.string().optional().catch(undefined),
    })
    .default({
      src: "",
    }),
});

const defaultCarouselStyleAttributes = {
  "left-icon":
    "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/arrows/arrow-3/simple/outline/black-L.png",
  "right-icon":
    "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/arrows/arrow-3/simple/outline/black-R.png",
  containerWidth: 600,
  "icon-width": "44px",
  "tb-width": "110px",
  "tb-border-radius": "6px",
  padding: "10px 15px 10px 15px",
  "tb-hover-border-color": "#fead0d",
  "tb-selected-border-color": "#cacaca",
};

export const TopolCarouselStyleAttributesSchema = z.object({
  "icon-width": z.string().catch(defaultCarouselStyleAttributes["icon-width"]),
  "tb-width": z.string().catch(defaultCarouselStyleAttributes["tb-width"]),
  "tb-border-radius": z
    .string()
    .catch(defaultCarouselStyleAttributes["tb-border-radius"]),
  padding: z.string().catch(defaultCarouselStyleAttributes["padding"]),
  "tb-hover-border-color": z
    .string()
    .catch(defaultCarouselStyleAttributes["tb-hover-border-color"]),
  "tb-selected-border-color": z
    .string()
    .catch(defaultCarouselStyleAttributes["tb-selected-border-color"]),
  thumbnails: z.enum(["hidden", "visible"]).optional().catch(undefined),
  "border-radius": z.string().optional().catch(undefined),
});

export const TopolCarouslBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-carousel"),
  attributes: z
    .object({
      "left-icon": z
        .string()
        .catch(defaultCarouselStyleAttributes["left-icon"]),
      "right-icon": z
        .string()
        .catch(defaultCarouselStyleAttributes["right-icon"]),
      containerWidth: z.number().catch(600),
      ...TopolCarouselStyleAttributesSchema.shape,
    })
    .default(defaultCarouselStyleAttributes),
  children: z.array(TopolCarouslElementSchema).default([]),
});

export type TopolCarouslBlock = z.infer<typeof TopolCarouslBlockSchema>;
